import styled from "styled-components";
import { theme } from "styles/theme";

const StyledMenuMobileWrap = styled.div`
  padding: 20px;
  .list {
    padding: 20px;
    &-name {
      max-width: 480px;
      margin: auto;
      padding: 20px 70px;
      h3 {
        text-align: center;
        font-weight: normal;
        font-size: 25px;
        color: white;
        text-transform: uppercase;
        font-weight: 500;
      }
    }
    &-menu {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 11px;
      margin: auto;
      &-item {
        height: 70px;
        color: #fff;
        border: 1px solid #fff;
        border-radius: 2px;
        &.--active {
          border-color: ${theme.colors.secondary[900]};
          color: ${theme.colors.secondary[900]};
          a {
            .icon {
              color: ${theme.colors.secondary[900]};
            }
            .text {
              color: ${theme.colors.secondary[900]};
            }
          }
        }
        &:hover {
          border-color: ${theme.colors.secondary[900]};
          transition: 0.4s;
          .link {
            color: ${theme.colors.secondary[900]};
            transition: 0.4s;
          }
        }
        .link {
          text-decoration: none;
          color: white;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          height: 100%;
          width: 100%;
          padding: 0 5px;
          .icon {
            position: relative;
            color: white;
            font-size: 18px;
          }
          .text {
            font-weight: 500;
            font-size: 11px;
          }
        }
      }
    }
  }
`;
export default StyledMenuMobileWrap;
